import $ from 'jquery';
import whatInput from 'what-input';

window.$ = $;
window.jQuery = $;

import Foundation from 'foundation-sites';

$(function() {
    $(document).foundation();
});
